let cachedIpAddress = null;

export const getIpAddress = async () => {
  if (cachedIpAddress !== null) {
    return cachedIpAddress;
  }

  try {
    const response = await fetch('https://ipapi.co/json/');

    if (!response.ok) {
      cachedIpAddress = '';
      return cachedIpAddress;
    }

    const data = await response.json();
    cachedIpAddress = data?.ip || '';
    return cachedIpAddress;
  } catch (error) {
    console.error('Failed to fetch IP address:', error);
    cachedIpAddress = '';
    return cachedIpAddress;
  }
};
